import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import {
    UiContentCol,
    UiContentWr,
} from "../../../components/common/UiPageElements";
import {
    UiCol,
    UiRowContainer,
    UiSingleRow,
} from "../../../components/grid-container/GridContainer";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import ProgressBar from "react-bootstrap/ProgressBar";
import Pointpointer from "../../../../../styles/img/point-pointer.png";
import TopDirection from "../../../../../styles/img/top-direction.png";
import BottomDirection from "../../../../../styles/img/bottom-direction.png";
import UiCustomerSelect from "../../../../_uiComponents/form/UiCustomerSelect";
import {
    participantTypeIds,
    participantJobRoleIds,
} from "../../../../../_redux/_constants";
import {
    getTlcCustomerRequest,
    getGoldRushCampaignPerformanceSummaryRequest,
    campaignGetTlcRetailersRequest,
    campaignGetTLCCustomerByDealersRequest,
    campaignGetAreaManagerDealersRequest,
} from "../../../../../_redux/_actions";
import UiDealerSelect from "../../../../_uiComponents/common/UiDealerSelect";

export const RoadToRewards = (props) => {
    const actionDispatch = useDispatch();
    const [selectedArea, setSelectedArea] = useState({ value: 11, label: 11 });

    const currentMonth = new Date().getMonth() + 1
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [changeMonth, setChangeMoths] = useState({ value: 6, label: "June" })

    const handleMonth = (month) => {
        setSelectedMonth(month);
    };

    const monthsOptions = [
        { value: 1, label: "January" },
        { value: 2, label: "February" },
        { value: 3, label: "March" },
        { value: 4, label: "April" },
        { value: 5, label: "May" },
        { value: 6, label: "June" },
    ];


    const [retailerObj, setRetailerObj] = useState(null);
    const [customerObj, setCustomerObj] = useState({});
    const [selectedDealer, setSelectedDealer] = useState(null);
    const [selectArea, setSelectArea] = useState(null);


    const { auth, tlcCustomers, getGoldRushCampaignPerformanceSummary, TLCRetailes, TradePartTlcCustomers, areaManagerDealers, area, userProfileDetails } =
        useSelector((state) => {
            return {
                auth: state.auth,
                tlcCustomers: state.campaign.tlcCustomers,
                getGoldRushCampaignPerformanceSummary:
                    state.campaign.getGoldRushCampaignPerformanceSummary,
                TLCRetailes:state.campaign.TLCRetailes,
                TradePartTlcCustomers: state.campaign.TradePartTlcCustomers,
                areaManagerDealers: state.campaign,
                area: state?.auth?.userProfileDetails,
                userProfileDetails: state.auth.userProfileDetails,
                
            };
        });

    const totalTargetPercentage =
        getGoldRushCampaignPerformanceSummary.bronzeTarget +
        getGoldRushCampaignPerformanceSummary.silverTarget +
        getGoldRushCampaignPerformanceSummary.goldTarget;

    const monthByNumber = () => {
        if (props.month === "October") {
            return {
                month:"10",
                year:"2024"
            };
        }
        if (props.month === "November") {
            return {
                month:"11",
                year:"2024"
            };
        }
        if (props.month === "December") {

            return {
                month:"12",
                year:"2024"
            };
        }
        if (props.month === "January") {
            return {
                month:"1",
                year:"2025"
            };
        }
        if (props.month === "February") {
            return {
                month:"2",
                year:"2025"
            };
        }
        if (props.month === "March") {
            return {
                month:"3",
                year:"2025"
            };
        }
        if (props.month === "April") {
            return {
                month:"4",
                year:"2025"
            };
        }
        if (props.month === "May") {
            return {
                month:"5",
                year:"2025"
            };
        }

        if (props.month === "June") {
            return {
                month:"6",
                year:"2025"
            };
        }
        
    }

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];

    const { jobRoleId } = auth.userProfileDetails || {};

    const isTlcCustomer = jobRoleId === participantJobRoleIds.TLC_PARTICIPANT_CUSTOMER;
    const isTlcAreaManager = jobRoleId === participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER;
    const isTradePartAreaManager = jobRoleId === participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER;
    const isSupperAreaManager = auth?.userProfileDetails?.jobRoleId === participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER;

    useEffect(() => {
        if (
            selectArea === null &&
            userProfileDetails?.jobRoleId ===
                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER
        ) {
            const areaId = area?.area === "0" ? "11" : area?.area;
            actionDispatch(
                campaignGetAreaManagerDealersRequest({
                    particpantId: area?.participantIds[0],
                    areaId,
                }),
            );
        }
    }, [area.area]);


    useEffect(() => {
        actionDispatch(campaignGetTlcRetailersRequest({
            roleId:auth.userProfileDetails.jobRoleId
        }));
    },[]);

    useEffect(() => {
        if(auth.userProfileDetails.jobRoleId ===
            participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER){
                if(retailerObj !== null){
                    actionDispatch(getTlcCustomerRequest({...retailerObj}));
                }
                else{
        
                    if(TLCRetailes?.length !== 0){
                        actionDispatch(getTlcCustomerRequest(
                            { reatilerId: TLCRetailes[0]?.id, reatilerName: TLCRetailes[0]?.name }
                    ));
                    }
                }
            }

            if(auth.userProfileDetails.jobRoleId === participantJobRoleIds.TLC_TRADE_REP) {
               const retailerObj = { reatilerId: userProfileDetails?.dealerships?.[0]?.dealerId, reatilerName: userProfileDetails?.dealerships?.[0]?.dealerName }
               // const retailerObj = { reatilerId: 348, reatilerName: userProfileDetails?.dealerships?.[0]?.dealerName }
               actionDispatch(getTlcCustomerRequest({...retailerObj}));
            }


    }, [retailerObj])

    const getGoldRushCampaignPerformanceSummaryData = (customerId) => {
        if (customerId) {
            actionDispatch(
                getGoldRushCampaignPerformanceSummaryRequest({ customerId: customerId, month: selectedMonth, year:monthByNumber()?.year }),
            );
        }
    };

    useEffect(() => {
        if (selectedArea !== null && (userProfileDetails?.jobRoleId !== participantJobRoleIds.TLC_TRADE_REP  && userProfileDetails?.jobRoleId !== participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER)) {
            actionDispatch(
                campaignGetAreaManagerDealersRequest({
                    particpantId: auth?.userProfileDetails?.participantIds[0],
                    areaId: selectedArea?.value,
                }),
            );
        }
    }, [selectedArea]);

    useEffect(
        function () {
            if (
                (auth.userProfileDetails.jobRoleId ==
                participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER || isTradePartAreaManager)
            ) {
                if (typeof tlcCustomers[0] != "undefined") {

                    setSelectedDealer(tlcCustomers[0])
                    getGoldRushCampaignPerformanceSummaryData(
                        customerObj.customerNo,
                        selectedMonth
                    );
                }
            } else {
                getGoldRushCampaignPerformanceSummaryData(
                    auth.userProfileDetails.tlcCustomerNo,
                    selectedMonth
                );
            }

            

            if(auth.userProfileDetails.jobRoleId === participantJobRoleIds.TLC_TRADE_REP){
                 getGoldRushCampaignPerformanceSummaryData(
                     customerObj.customerNo,
                     selectedMonth
                 );
            }

        },

        [auth.userProfileDetails, selectedMonth],
    );

    useEffect(() => {
        if(isSupperAreaManager || auth.userProfileDetails.jobRoleId ==
            participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER){
            if(customerObj?.customerNo === undefined){
                getGoldRushCampaignPerformanceSummaryData(
                    tlcCustomers[0]?.customerNo,
                    selectedMonth
                );
            }else {
                getGoldRushCampaignPerformanceSummaryData(
                    customerObj?.customerNo,
                    selectedMonth
                );
            }
            
        }
    }, [customerObj, selectedMonth, actionDispatch, tlcCustomers])

    useEffect(() => {
        if(auth.userProfileDetails.jobRoleId ==
            participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER){
                if(typeof auth.userProfileDetails?.dealerships[0] !== undefined){
                    actionDispatch(campaignGetTLCCustomerByDealersRequest({
                        dealerCode:auth.userProfileDetails?.dealerships[0]?.dealerCode
                    }))
                    
                }
            }
        if(isSupperAreaManager || auth.userProfileDetails.jobRoleId ==
            participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER){
            if(selectedDealer === null){
                actionDispatch(campaignGetTLCCustomerByDealersRequest({
                    dealerCode:areaManagerDealers?.areaManagerDealers?.[0]?.code
                }))
            }else{
                const isValueEmpty = (obj) => !obj?.value?.trim();
                if(!isValueEmpty(selectedDealer)){
                    actionDispatch(campaignGetTLCCustomerByDealersRequest({
                        dealerCode:selectedDealer?.value
                    }))
                }
            }
        }
    } ,[auth.userProfileDetails, selectedDealer, selectedArea]);

    const SuperAreOption = [
        { code: 11, name: 11 },
        { code: 12, name: 12 },
        { code: 13, name: 13 },
        { code: 14, name: 14 },
        { code: 15, name: 15 },
        { code: 16, name: 16 },
        { code: 17, name: 17 },
    ];

    console.log('auth?.userProfileDetails?.jobRoleId', auth?.userProfileDetails?.jobRoleId);
    

    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid">
                    <UiCol lg="12" className="sb-reward-bar">
                        <UiContentCol>
                            {/* TLC Manager only*/}
                            {(auth?.userProfileDetails?.roleId ==
                                participantTypeIds.TLC_PARTICIPANT || auth?.userProfileDetails?.roleId ==
                                participantTypeIds.PARTICIPANT)
                                 &&
                                (auth?.userProfileDetails?.jobRoleId ==
                                participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER || auth?.userProfileDetails?.jobRoleId ==
                                participantJobRoleIds.TLC_PARTICIPANT_CUSTOMER || 
                                auth?.userProfileDetails?.jobRoleId ==
                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER ||
                                auth?.userProfileDetails?.jobRoleId ==
                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER ||
                                auth?.userProfileDetails?.jobRoleId == participantJobRoleIds.TLC_TRADE_REP || isSupperAreaManager) && (
                                    <>
                                        {(auth?.userProfileDetails?.roleId ==
                                            participantTypeIds.TLC_PARTICIPANT || auth?.userProfileDetails?.roleId ==
                                            participantTypeIds.PARTICIPANT) && (auth?.userProfileDetails?.jobRoleId ==
                                            participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER || auth?.userProfileDetails?.jobRoleId ==
                                            participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER || 
                                             auth?.userProfileDetails?.jobRoleId == participantJobRoleIds.TLC_TRADE_REP || auth?.userProfileDetails?.jobRoleId || isSupperAreaManager) &&

                                            <div className="sb-reward-customer-details-wr">
                                            <h5>Select your customer</h5>
                                            <div className="sb-reward-customer-details">
                                            {(isSupperAreaManager || auth?.userProfileDetails?.jobRoleId == participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER) &&
                                            <>
                                                {isSupperAreaManager && 
                                                <>
                                                    <div className="sb-performance-dealer-select  sb-quarter-dealer-select">
                                                        <UiDealerSelect
                                                            dealerOptions={SuperAreOption.map(
                                                                (area) => {
                                                                    return {
                                                                        value: area.code,
                                                                        label: area.name,
                                                                    };
                                                                },
                                                            )}
                                                            isDashBoard={false}
                                                            onChange={(value) => {
                                                                setSelectedArea(value);
                                                                setSelectedDealer({value:"", label:""});
                                                            }}
                                                            selectedDealer={selectedArea}
                                                        />
                                                    </div>
                                                </>}

                                                <div className="sb-performance-dealer-select sb-quarter-dealer-select sb-dealer-select-moto-gp">
                                                <UiDealerSelect
                                                dealerOptions={areaManagerDealers?.areaManagerDealers.map(
                                                    (dealerships) => {
                                                        return {
                                                            value: dealerships.code,
                                                            label: dealerships.name,
                                                        };
                                                    },
                                                )}
                                                dealerships={
                                                    areaManagerDealers?.areaManagerDealers
                                                }
                                                isDashBoard={false}
                                                isAreaManager={false}
                                                selectDealer={true}
                                                onChange={(value) => {
                                                    setSelectedDealer(value);
                                                    setCustomerObj({ customerNo: "", customerName: "" });
                                                }}
                                                selectedDealer={selectedDealer}
                                                />
                                            </div>
                                            </>
                                            }
                                            {((auth?.userProfileDetails?.jobRoleId ==
                                                participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER) && TLCRetailes.length !== 0) &&
                                                <div className="sb-performance-dealer-select sb-reward-customer-details__select">
                                                    <UiCustomerSelect
                                                        label="Retailer"
                                                        onChange={(value) => {
                                                            setRetailerObj({ reatilerId: value.value, reatilerName: value.label });
                                                        }}
                                                        options={TLCRetailes.map(
                                                            function (tlcCustomer) {
                                                                return {
                                                                    value: tlcCustomer.id,
                                                                    label: tlcCustomer.name,
                                                                };
                                                            },
                                                        )}
                                                        defaultValue={
                                                            (retailerObj === null)
                                                                ? {
                                                                    value: TLCRetailes[0]?.id,
                                                                    label: TLCRetailes[0]?.name,
                                                                }
                                                                : {
                                                                    value: retailerObj.reatilerId,
                                                                    label: retailerObj.reatilerName,
                                                                }
                                                        }
                                                    />
                                                </div>
                                                }
                                            {(auth?.userProfileDetails?.jobRoleId ==
                                                participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER || auth?.userProfileDetails?.jobRoleId ==
                                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER ||
                                                auth?.userProfileDetails?.jobRoleId ==
                                                participantJobRoleIds.TLC_TRADE_REP || auth.userProfileDetails.jobRoleId ==
                                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER || 
                                                isSupperAreaManager) && tlcCustomers.length !== 0 &&
                                                <div className="sb-performance-dealer-select sb-reward-customer-details__select">
                                                <UiCustomerSelect
                                                    label="Customer"
                                                    onChange={(value) => {
                                                        setCustomerObj({ customerNo: value.value, customerName: value.label });
                                                        if(!isSupperAreaManager){
                                                            getGoldRushCampaignPerformanceSummaryData(
                                                                value.value,
                                                            );
                                                        }
                                                    }}
                                                    options={tlcCustomers.map(
                                                        function (tlcCustomer) {
                                                            return {
                                                                value: tlcCustomer.customerNo,
                                                                label: tlcCustomer.customerName,
                                                            };
                                                        },
                                                    )}
                                                    placeholder={"Enter Customer Name"}
                                                    defaultValue={
                                                        tlcCustomers.length !== 0
                                                            ? {
                                                                value: customerObj
                                                                    .customerNo,
                                                                label: customerObj
                                                                    .customerName,
                                                            }
                                                            : null
                                                    }
                                                />
                                            </div>
                                            }
                                             <div className="sb-performance-dealer-select sb-reward-customer-details__select">
                                             <UiCustomerSelect
                                                label="Month"
                                                onChange={(e) => {
                                                    setChangeMoths(e)
                                                    handleMonth(e.value);
                                                    setCustomerObj({ customerNo: customerObj?.customerNo, customerName: customerObj?.customerName });
                                                }}
                                                options={monthsOptions}
                                                defaultValue={changeMonth}
                                            />

                                            </div>
                                        </div>
                                        </div>
                                        }
                                        

                                        {(auth?.userProfileDetails?.jobRoleId ==
                                            participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER || auth?.userProfileDetails?.jobRoleId ==
                                            participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER || auth?.userProfileDetails?.jobRoleId ==
                                            participantJobRoleIds.TLC_TRADE_REP || auth.userProfileDetails.jobRoleId ==
                                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER || isSupperAreaManager) &&
                                            <>
                                            {tlcCustomers.length !== 0 ? 
                                                <div className="sb-reward-customer-name-wr" style={getGoldRushCampaignPerformanceSummary?.isAccountActivated ? {backgroundColor:'#35F29A'}:{backgroundColor:'#E64A26'}}>
                                                { customerObj?.customerNo || customerObj?.customerName ? <h5>
                                                   <span>{getGoldRushCampaignPerformanceSummary?.isAccountActivated ? `${customerObj?.customerNo} | ${customerObj?.customerName} | ACTIVATED` : `${customerObj?.customerNo} | ${customerObj?.customerName} | NOT ACTIVATED`}</span>
                                                </h5> :''
                                                }
                                            </div> : 
                                            <div className="sb-reward-customer-name">
                                                <h5>
                                                    {'No customers found for selected retailer!'}
                                                </h5>
                                            </div>
                                            }
                                            </>
                                        }
                                    </>
                                )}
                            {/* TLC Manager only*/}
                            {auth?.userProfileDetails?.jobRoleId === participantJobRoleIds.TLC_PARTICIPANT_CUSTOMER && getGoldRushCampaignPerformanceSummary !== null &&
                            <>
                            <UiCardTitle title={`Your road to rewards - ${((isSupperAreaManager || isTradePartAreaManager) ? months[selectedMonth - 1] : months[selectedMonth - 1])}`}  />
                            <UiCardTitle title={`Customer's road to rewards`} />
                            <UiSingleRow>
                                <div className="sb-point-porgress">
                                    <div
                                        className="sb-point-top-pointer"
                                        style={{
                                            left: getGoldRushCampaignPerformanceSummary?.totalSales > 0 &&

                                                getGoldRushCampaignPerformanceSummary?.totalSales <=
                                                getGoldRushCampaignPerformanceSummary?.bronzeTarget
                                                ?
                                                `${(
                                                    getGoldRushCampaignPerformanceSummary?.totalSales) /
                                                totalTargetPercentage * 100}%`
                                                :
                                                getGoldRushCampaignPerformanceSummary?.totalSales <=
                                                    getGoldRushCampaignPerformanceSummary?.silverTarget &&
                                                    getGoldRushCampaignPerformanceSummary?.totalSales >
                                                    getGoldRushCampaignPerformanceSummary?.bronzeTarget

                                                    ?
                                                    `${(getGoldRushCampaignPerformanceSummary?.totalSales +
                                                        getGoldRushCampaignPerformanceSummary?.bronzeTarget)
                                                    /
                                                    totalTargetPercentage

                                                    * 100}%`

                                                    :
                                                    getGoldRushCampaignPerformanceSummary?.totalSales >
                                                        getGoldRushCampaignPerformanceSummary?.silverTarget &&
                                                        getGoldRushCampaignPerformanceSummary?.totalSales <=
                                                        getGoldRushCampaignPerformanceSummary?.goldTarget ?

                                                        `${((getGoldRushCampaignPerformanceSummary?.totalSales /
                                                            getGoldRushCampaignPerformanceSummary?.goldTarget
                                                        ) * 100) - 1}%`

                                                        : '0%'
                                        }}
                                    >
                                        <a className="my-anchor-element-top">
                                            {" "}
                                            <span />{" "}
                                        </a>
                                        {getGoldRushCampaignPerformanceSummary?.gapMessage &&
                                            <Tooltip
                                                place={"top"}
                                                isOpen={true}
                                                anchorSelect=".my-anchor-element-top"
                                                content={
                                                    <>
                                                        <span>
                                                            {getGoldRushCampaignPerformanceSummary?.totalSales < 0 ?
                                                                `Only £ ${getGoldRushCampaignPerformanceSummary?.bronzeTarget} away from Bronze` :
                                                                getGoldRushCampaignPerformanceSummary?.gapMessage}

                                                        </span>
                                                    </>
                                                }
                                            />
                                        }

                                    </div>

                                    <div
                                        className="sb-point-pointer"

                                        style={{
                                            left: getGoldRushCampaignPerformanceSummary?.totalSales > 0 &&

                                                getGoldRushCampaignPerformanceSummary?.totalSales <=
                                                getGoldRushCampaignPerformanceSummary?.bronzeTarget
                                                ?
                                                `${((
                                                    getGoldRushCampaignPerformanceSummary?.totalSales) /
                                                totalTargetPercentage * 100 ) - 1}%`
                                                :
                                                getGoldRushCampaignPerformanceSummary?.totalSales <=
                                                    getGoldRushCampaignPerformanceSummary?.silverTarget &&
                                                    getGoldRushCampaignPerformanceSummary?.totalSales >
                                                    getGoldRushCampaignPerformanceSummary?.bronzeTarget

                                                    ?
                                                    `${((getGoldRushCampaignPerformanceSummary?.totalSales +
                                                        getGoldRushCampaignPerformanceSummary?.bronzeTarget)
                                                    /
                                                    totalTargetPercentage

                                                    * 100 ) - 1}%`

                                                    :
                                                    getGoldRushCampaignPerformanceSummary?.totalSales >
                                                        getGoldRushCampaignPerformanceSummary?.silverTarget &&
                                                        getGoldRushCampaignPerformanceSummary?.totalSales <=
                                                        getGoldRushCampaignPerformanceSummary?.goldTarget ?

                                                        `${((getGoldRushCampaignPerformanceSummary?.totalSales /
                                                            getGoldRushCampaignPerformanceSummary?.goldTarget
                                                        ) * 100) - 1}%`

                                                        : getGoldRushCampaignPerformanceSummary?.totalSales >
                                                            getGoldRushCampaignPerformanceSummary?.goldTarget ?
                                                            `${(1 * 100) - 1}%` : '0%'
                                        }}
                                    >
                                        <a className="my-anchor-element sb-road-to-rewards-icon-wr">
                                            <span className="sb-road-to-rewards-target-icon"></span>
                                            {/* <img src={Pointpointer} /> */}
                                        </a>
                                        {getGoldRushCampaignPerformanceSummary?.rewardMessage &&
                                            <Tooltip
                                                place={"bottom"}
                                                isOpen={true}
                                                anchorSelect=".my-anchor-element"
                                                content={
                                                    <>
                                                        <div className="sb-direction-mobile-scontainer">
                                                            <div className="sb-bottom-direction">
                                                                <div className="sb-bottom-direction__box">
                                                                    <span>
                                                                        You are here
                                                                        with:
                                                                    </span>
                                                                    <label>
                                                                        {
                                                                            getGoldRushCampaignPerformanceSummary?.rewardMessage
                                                                        }
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {getGoldRushCampaignPerformanceSummary?.isWinner && 
                                                        <div className="sb-reward-winner-label">
                                                            <h3>Winner</h3>
                                                        </div>
                                                        }
                                                        
                                                    </>
                                                }
                                            />
                                        }
                                    </div>

                                    <div className="sb-progress-bar-heading">
                                        <span
                                            style={{
                                                width: `${(getGoldRushCampaignPerformanceSummary?.bronzeTarget /
                                                    totalTargetPercentage) *
                                                    100
                                                    }%`,
                                            }}
                                        >
                                            Bronze Reward: £
                                            {
                                                getGoldRushCampaignPerformanceSummary?.bronzeReward
                                            }{" "}
                                        </span>
                                        <span
                                            style={{
                                                width: `${(getGoldRushCampaignPerformanceSummary?.silverTarget /
                                                    totalTargetPercentage) *
                                                    100
                                                    }%`,
                                            }}
                                        >
                                            Silver Reward: £
                                            {
                                                getGoldRushCampaignPerformanceSummary?.silverReward
                                            }{" "}
                                        </span>
                                        <span
                                            style={{
                                                width: `${(getGoldRushCampaignPerformanceSummary?.goldTarget /
                                                    totalTargetPercentage) *
                                                    100
                                                    }%`,
                                            }}
                                        >
                                            Gold Reward: £
                                            {
                                                getGoldRushCampaignPerformanceSummary?.goldReward
                                            }{" "}
                                        </span>
                                    </div>
                                    <ProgressBar>
                                        <ProgressBar
                                            variant="success"
                                            label={`Target: £ ${getGoldRushCampaignPerformanceSummary?.bronzeTarget}`}
                                            now={
                                                (getGoldRushCampaignPerformanceSummary?.bronzeTarget /
                                                    totalTargetPercentage) *
                                                100
                                            }
                                            key={1}
                                        />
                                        <ProgressBar
                                            variant="danger"
                                            label={`Target: £ ${getGoldRushCampaignPerformanceSummary?.silverTarget}`}
                                            now={
                                                (getGoldRushCampaignPerformanceSummary?.silverTarget /
                                                    totalTargetPercentage) *
                                                100
                                            }
                                            key={2}
                                        />
                                        <ProgressBar
                                            variant="warning"
                                            label={`Target: £ ${getGoldRushCampaignPerformanceSummary?.goldTarget}`}
                                            now={
                                                (getGoldRushCampaignPerformanceSummary?.goldTarget /
                                                    totalTargetPercentage) *
                                                100
                                            }
                                            key={3}
                                        />
                                    </ProgressBar>
                                </div>
                            </UiSingleRow>
                            </>
                            }
                            {(auth?.userProfileDetails?.jobRoleId === participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER || auth?.userProfileDetails?.jobRoleId === participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER || auth?.userProfileDetails?.jobRoleId ==
                                            participantJobRoleIds.TLC_TRADE_REP || auth.userProfileDetails.jobRoleId ==
                                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER || isSupperAreaManager) && tlcCustomers.length !== 0 && getGoldRushCampaignPerformanceSummary?.month &&
                            <>
                            <UiCardTitle title={`Your road to rewards - ${((isSupperAreaManager || isTradePartAreaManager) ? months[selectedMonth - 1] : months[selectedMonth - 1])}`} />
                            <UiSingleRow>
                                <div className="sb-point-porgress">
                                    <div
                                        className="sb-point-top-pointer"
                                        style={{
                                            left: getGoldRushCampaignPerformanceSummary?.totalSales > 0 &&

                                                getGoldRushCampaignPerformanceSummary?.totalSales <=
                                                getGoldRushCampaignPerformanceSummary?.bronzeTarget
                                                ?
                                                `${(
                                                    getGoldRushCampaignPerformanceSummary?.totalSales) /
                                                totalTargetPercentage * 100}%`
                                                :
                                                getGoldRushCampaignPerformanceSummary?.totalSales <=
                                                    getGoldRushCampaignPerformanceSummary?.silverTarget &&
                                                    getGoldRushCampaignPerformanceSummary?.totalSales >
                                                    getGoldRushCampaignPerformanceSummary?.bronzeTarget

                                                    ?
                                                    `${(getGoldRushCampaignPerformanceSummary?.totalSales +
                                                        getGoldRushCampaignPerformanceSummary?.bronzeTarget)
                                                    /
                                                    totalTargetPercentage

                                                    * 100}%`

                                                    :
                                                    getGoldRushCampaignPerformanceSummary?.totalSales >
                                                        getGoldRushCampaignPerformanceSummary?.silverTarget &&
                                                        getGoldRushCampaignPerformanceSummary?.totalSales <=
                                                        getGoldRushCampaignPerformanceSummary?.goldTarget ?

                                                        `${((getGoldRushCampaignPerformanceSummary?.totalSales /
                                                            getGoldRushCampaignPerformanceSummary?.goldTarget
                                                        ) * 100) - 1}%`

                                                        : '0%'
                                        }}
                                    >
                                        <a className="my-anchor-element-top">
                                            {" "}
                                            <span />{" "}
                                        </a>
                                        {getGoldRushCampaignPerformanceSummary?.gapMessage &&
                                            <Tooltip
                                                place={"top"}
                                                isOpen={true}
                                                anchorSelect=".my-anchor-element-top"
                                                content={
                                                    <>
                                                        <span>
                                                            {getGoldRushCampaignPerformanceSummary?.totalSales < 0 ?
                                                                `Only £ ${getGoldRushCampaignPerformanceSummary?.bronzeTarget} away from Bronze` :
                                                                getGoldRushCampaignPerformanceSummary?.gapMessage}

                                                        </span>
                                                    </>
                                                }
                                            />
                                        }

                                    </div>

                                    <div
                                        className="sb-point-pointer"

                                        style={{
                                            left: getGoldRushCampaignPerformanceSummary?.totalSales > 0 &&

                                                getGoldRushCampaignPerformanceSummary?.totalSales <=
                                                getGoldRushCampaignPerformanceSummary?.bronzeTarget
                                                ?
                                                `${((
                                                    getGoldRushCampaignPerformanceSummary?.totalSales) /
                                                totalTargetPercentage * 100) - 1}%`
                                                :
                                                getGoldRushCampaignPerformanceSummary?.totalSales <=
                                                    getGoldRushCampaignPerformanceSummary?.silverTarget &&
                                                    getGoldRushCampaignPerformanceSummary?.totalSales >
                                                    getGoldRushCampaignPerformanceSummary?.bronzeTarget

                                                    ?
                                                    `${((getGoldRushCampaignPerformanceSummary?.totalSales +
                                                        getGoldRushCampaignPerformanceSummary?.bronzeTarget)
                                                    /
                                                    totalTargetPercentage

                                                    * 100) - 1}%`

                                                    :
                                                    getGoldRushCampaignPerformanceSummary?.totalSales >
                                                        getGoldRushCampaignPerformanceSummary?.silverTarget &&
                                                        getGoldRushCampaignPerformanceSummary?.totalSales <=
                                                        getGoldRushCampaignPerformanceSummary?.goldTarget ?

                                                        `${((getGoldRushCampaignPerformanceSummary?.totalSales /
                                                            getGoldRushCampaignPerformanceSummary?.goldTarget
                                                        ) * 100) - 1}%`

                                                        : getGoldRushCampaignPerformanceSummary?.totalSales >
                                                            getGoldRushCampaignPerformanceSummary?.goldTarget ?
                                                            `${(1 * 100) - 1}%` : '0%'
                                        }}
                                    >
                                        <a className="my-anchor-element sb-road-to-rewards-icon-wr">
                                            <span className="sb-road-to-rewards-target-icon"></span>
                                            {/* <img src={Pointpointer} /> */}
                                        </a>
                                        {getGoldRushCampaignPerformanceSummary?.rewardMessage &&
                                            <Tooltip
                                                place={"bottom"}
                                                isOpen={true}
                                                anchorSelect=".my-anchor-element"
                                                content={
                                                    <>
                                                        <div className="sb-direction-mobile-scontainer">
                                                            <div className="sb-bottom-direction">
                                                                <div className="sb-bottom-direction__box">
                                                                    <span>
                                                                        You are here
                                                                        with:
                                                                    </span>
                                                                    <label>
                                                                        {
                                                                            getGoldRushCampaignPerformanceSummary?.rewardMessage
                                                                        }
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {getGoldRushCampaignPerformanceSummary?.isWinner && 
                                                        <div className="sb-reward-winner-label">
                                                            <h3>Winner</h3>
                                                        </div>
                                                        }
                                                        
                                                    </>
                                                }
                                            />
                                        }
                                    </div>

                                    <div className="sb-progress-bar-heading">
                                        <span
                                            style={{
                                                width: `${(getGoldRushCampaignPerformanceSummary?.bronzeTarget /
                                                    totalTargetPercentage) *
                                                    100
                                                    }%`,
                                            }}
                                        >
                                            Bronze Reward: £
                                            {
                                                getGoldRushCampaignPerformanceSummary?.bronzeReward
                                            }{" "}
                                        </span>
                                        <span
                                            style={{
                                                width: `${(getGoldRushCampaignPerformanceSummary?.silverTarget /
                                                    totalTargetPercentage) *
                                                    100
                                                    }%`,
                                            }}
                                        >
                                            Silver Reward: £
                                            {
                                                getGoldRushCampaignPerformanceSummary?.silverReward
                                            }{" "}
                                        </span>
                                        <span
                                            style={{
                                                width: `${(getGoldRushCampaignPerformanceSummary?.goldTarget /
                                                    totalTargetPercentage) *
                                                    100
                                                    }%`,
                                            }}
                                        >
                                            Gold Reward: £
                                            {
                                                getGoldRushCampaignPerformanceSummary?.goldReward
                                            }{" "}
                                        </span>
                                    </div>
                                    <ProgressBar>
                                        <ProgressBar
                                            variant="success"
                                            label={`Target: £ ${getGoldRushCampaignPerformanceSummary?.bronzeTarget}`}
                                            now={
                                                (getGoldRushCampaignPerformanceSummary?.bronzeTarget /
                                                    totalTargetPercentage) *
                                                100
                                            }
                                            key={1}
                                        />
                                        <ProgressBar
                                            variant="danger"
                                            label={`Target: £ ${getGoldRushCampaignPerformanceSummary?.silverTarget}`}
                                            now={
                                                (getGoldRushCampaignPerformanceSummary?.silverTarget /
                                                    totalTargetPercentage) *
                                                100
                                            }
                                            key={2}
                                        />
                                        <ProgressBar
                                            variant="warning"
                                            label={`Target: £ ${getGoldRushCampaignPerformanceSummary?.goldTarget}`}
                                            now={
                                                (getGoldRushCampaignPerformanceSummary?.goldTarget /
                                                    totalTargetPercentage) *
                                                100
                                            }
                                            key={3}
                                        />
                                    </ProgressBar>
                                </div>
                            </UiSingleRow>
                            </>
                        }







                        </UiContentCol>
                    </UiCol>
                </UiRowContainer>
            </UiContentWr>
        </>
    );
};
